import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../store/auth/hooks";

export default function AuthPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/app");
    } else {
      if (location.pathname === "/") navigate("/login");
    }
  }, [isAuthenticated, location, navigate]);

  return (
    <div>
      <Outlet />
    </div>
  );
}
